<mat-card class="nsc-card"  [ngClass]="error ? 'mat-card--error' : ''"><ng-content></ng-content></mat-card>